// eslint-disable-next-line import/prefer-default-export
export const ROOM_TYPES = {
  HALL: "hall",
  PRIVATE: "private",
  SEMI_PRIVATE: "semi_private",
  ISOLATION: "isolation"
} as const;
